import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { PARTNER_CONSOLIDATED_REPORTS_FLAG } from 'tio-employee/types/partner-reports';
import type FeaturesService from 'tio-common/services/features';
import type RouterService from '@ember/routing/router';

/**
 * A partner's view-only dashboard. It exists only alongside the consolidated Reports page:
 * with the flag off there is no dashboards listing to arrive from, so the URL falls back to
 * the reports page rather than rendering an unreachable viewer.
 */
export default class AuthenticatedAdminReportingDashboardViewerRoute extends Route {
  @service declare features: FeaturesService;
  @service declare router: RouterService;

  /** Sends a flag-off visitor to the reports page; otherwise falls through to the viewer. */
  beforeModel() {
    if (!this.features.isEnabled(PARTNER_CONSOLIDATED_REPORTS_FLAG)) {
      this.router.replaceWith('authenticated.admin.reporting.index');
    }
  }

  /** @returns the dashboard's report id; the template fetches it, so the route never waits */
  model(params: { dashboard_id: string }) {
    return { dashboardId: params.dashboard_id };
  }
}
